import { render, staticRenderFns } from "./ApiPayments.vue?vue&type=template&id=48b3726b"
import script from "./ApiPayments.vue?vue&type=script&lang=js"
export * from "./ApiPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports